import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'mailSubjectBodyLink'
})
export class MailSubjectBodyLinkPipe implements PipeTransform {
  transform(
    email: string,
    projectId: number,
    firstName?: string,
    line1?: string,
    postalCode?: string,
    city?: string,
    body?: string,
    projectLabel = 'Project'
  ) {
    return `mailto:${email}?Subject=${this.getMailSubjectLine(
      projectId,
      line1,
      postalCode,
      city,
      projectLabel
    )}&body=Beste ${firstName},${
      StringHelper.isEmpty(body) ? '' : encodeURIComponent('\n\n') + body
    }`;
  }

  private getMailSubjectLine(
    projectId: number,
    line1?: string,
    postalCode?: string,
    city?: string,
    projectLabel?: string
  ) {
    let toReturn = projectLabel + ' #' + projectId;
    const addressPart = StringHelper.join(
      [line1, StringHelper.join([postalCode, city], ' ')],
      ', '
    );
    return StringHelper.isEmpty(addressPart)
      ? toReturn
      : toReturn + ' / ' + addressPart;
  }
}
